import { strings as Localization } from "../../lib/Localization"
import { Button, Paper } from "@material-ui/core"
import React from "react"

function ShowNewsButton({ onClick }) {
    return (
        <Paper elevation={3} onClick={onClick} className="showNewsButton">
            <Button color="disable" variant="outlined">{Localization.showMoreNews}</Button>
        </Paper>
    )
}

export default ShowNewsButton
